package ru.malygin.dataConverter

import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.SupportForList
import ru.malygin.myConst.WeekDay


class MainScheduleItems(
    private val dataList: List<MainScheduleItemDto>?,
    private val category: SelectedCategory
) {

    private val groupedItems = dataList?.sortedBy {
        it.dayOfWeek
    }?.groupBy { it.dayOfWeek }?.values?.toList()

    /**
     * Сгруппированные данные для главного экрана
     *
     * (на все дни)
     */
    fun returnUiGroupedItems(

    ): List<List<MainScheduleItemDto>?>{
        when (category) {
            SelectedCategory.NONE -> {}
            SelectedCategory.GROUPS -> {}
            SelectedCategory.TUTORS -> Unit
            SelectedCategory.TEACHERS -> {
                val tempList = mutableListOf<List<MainScheduleItemDto>>()

                groupedItems?.map { item ->
                    tempList.add(item.sortedBy {
                        it.actualId
                    })
                }

                return tempList
            }
        }

        return groupedItems!!
    }

// зона дня

    private val groupedList = dataList?.groupBy { it.actualId }

    private val returnedList: MutableList<SupportForList> = mutableListOf()

    /**
     * Сгруппированные данные для главного экрана
     *
     * (на конкретный день)
     */
    fun returnSupportForList(

    ): List<SupportForList>?{
        when(category){
            SelectedCategory.NONE -> Unit
            SelectedCategory.GROUPS -> {
                dataList?.forEach { item->
                    returnedList.add(
                        mathReturn(
                            actualId = item.actualId,
                            items = listOf(item)
                        )
                    )
                }
            }
            SelectedCategory.TUTORS -> {
                dataList?.forEach { item->
                    returnedList.add(
                        mathReturn(
                            actualId = item.actualId,
                            items = listOf(item)
                        )
                    )
                }
            }
            SelectedCategory.TEACHERS -> {
                groupedList?.forEach{ (actualId, items) ->
                    returnedList.add(
                        mathReturn(
                            actualId = actualId,
                            items = items
                        )
                    )
                }
            }
        }

        val tempList = returnedList.toList().sortedBy { it.dataForOne?.dayOfWeek ?: it.dataForMore?.first()?.dayOfWeek }

        return tempList.ifEmpty { null }
    }

    private fun mathReturn(
        actualId: String,
        items: List<MainScheduleItemDto>
    ):SupportForList{
        return when{
            items.size == 1 -> {
                SupportForList(
                    id = items.getOrElse(0, defaultValue = {
                        MainScheduleItemDto(
                            id = it,
                            actualId = actualId,
                            dataAdded = "(❁´◡`❁)",
                            dayOfWeek = WeekDay.MONDAY,
                        )
                    }).id,
                    counter = 1,
                    dataForOne = items.getOrElse(
                        0, defaultValue = {
                            MainScheduleItemDto(
                                id = it,
                                actualId = actualId,
                                dataAdded = "(❁´◡`❁)",
                                dayOfWeek = WeekDay.MONDAY,
                            )
                        }
                    )
                )
            }
            items.size > 1 -> {
                SupportForList(
                    id = items.getOrElse(0, defaultValue = {
                        MainScheduleItemDto(
                            id = it,
                            actualId = actualId,
                            dataAdded = "(❁´◡`❁)",
                            dayOfWeek = WeekDay.MONDAY,
                        )
                    }).id,
                    counter = items.size,
                    dataForOne = null,
                    dataForMore = items
                )
            }
            else -> {
                SupportForList(
                    id = -1,
                    counter = null,
                    dataForOne = MainScheduleItemDto(
                        id = -1,
                        lessonName = "(❁´◡`❁)",
                        actualId = actualId,
                        dataAdded = "(❁´◡`❁)",
                        dayOfWeek = WeekDay.MONDAY,
                    ),
                    dataForMore = null
                )
            }
        }
    }
}